export let timeStr=time=>{
    let date=new Date(time);
    let year=date.getFullYear();
    let month=date.getMonth()+1;
    let day=date.getDate();
    let str='';
    if(month<=9){
        month='0' + month
    }

    if(day<=9){
        day='0' + day
    }
    
    str=year+'-'+month+'-'+day
    return str
}